import { useContext } from 'react';
import context from 'components/InstructionTestingLayout/context';
import { ResponderInstructionTestingContext, ResponderInstructionTestStepComponentProps } from '../../types';
import LLmInvokeOutputView from './Invoke';
import LLmConversationReplayOutputView from './replay';

const OutputView = ({
    agentId,
    responderId,
    systemMessageTemplate,
    onChange = () => {},
}: ResponderInstructionTestStepComponentProps) => {
    const { replayMode = false } = useContext<ResponderInstructionTestingContext>(context);

    if (replayMode) {
        return (
            <LLmConversationReplayOutputView
                agentId={agentId}
                responderId={responderId}
                systemMessageTemplate={systemMessageTemplate}
                onChange={onChange}
            />
        );
    }

    return (
        <LLmInvokeOutputView
            agentId={agentId}
            responderId={responderId}
            systemMessageTemplate={systemMessageTemplate}
            onChange={onChange}
        />
    );
};

export default OutputView;
